export default {
  login: {
    error: {
      title: 'Erreur d\'authentification',
      text: 'On dirait que vous avez entré un identifiant/mot de passe erroné... Essayez de nouveau !',
    },
  },
};
